import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'
import KEYCODE from 'keycode'

import ClickOutside from '../clickOutside'
import OnKeyDown from '../onKeyDown'
import FiltersMultiSelectPanel from './filtersPanel/multiSelect'
import { reportOpenSearchFilterPanel } from '../../../../common/analytics/filtersAnalytics'
import CodeIcon from '../../../shared/components/icons/code'
import RightOpenIcon from '../../../shared/components/icons/rightOpen'

class FiltersCompatibleWith extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showPanel: false
    }

    this.togglePanel = this.togglePanel.bind(this)
    this.onKeyDownHandler = this.onKeyDownHandler.bind(this)
  }

  onKeyDownHandler(event) {
    if (event.keyCode === KEYCODE('esc')) {
      this.togglePanel()
    }
  }

  togglePanel() {
    if (!this.state.showPanel) {
      reportOpenSearchFilterPanel('Compatible with')
    }
    this.setState({
      showPanel: !this.state.showPanel
    })
  }

  render() {
    const { showPanel } = this.state
    const { items, locationParams } = this.props

    const chosenCompatibleWith = locationParams.compatible_with || ''

    const renderChosenOptions = () => {
      if (chosenCompatibleWith === '') {
        return (
          <ul className="search-facet-listing">
            {items.map((item, index) => {
              return (
                <li key={index}>
                  <div className="search-facet-listing__link">
                    <span className="search-facet-listing__label">
                      {item.key}
                    </span>
                    <span className="search-facet-result-count">
                      {item.count}
                    </span>
                  </div>
                </li>
              )
            })}
          </ul>
        )
      } else {
        return (
          <div className="search-facet-panel__status fds-u-is-hidden--no-js">
            <div className="search-facet-panel__status-row">
              <div className="search-facet-panel__status-title">
                {chosenCompatibleWith.split(',').join(', ')}
              </div>
            </div>
          </div>
        )
      }
    }

    const { isAtTop } = this.props
    const panelHeaderClassNames = classNames({
      'search-facet-panel__header--one-facet': isAtTop,
      'search-facet-panel__header--end': !isAtTop,
      'is-active': showPanel
    })

    return (
      <div className="search-facet--no-margin" id="compatible-with-filter">
        <div className={panelHeaderClassNames} onClick={this.togglePanel}>
          <h2>
            <CodeIcon /> Compatible with
            <span style={{ float: 'right' }}>
              <RightOpenIcon />
            </span>
          </h2>
          {renderChosenOptions()}
        </div>

        {showPanel && (
          <OnKeyDown onKeyDown={this.onKeyDownHandler}>
            <ClickOutside onClickOutside={this.togglePanel}>
              <FiltersMultiSelectPanel
                type="compatible_with"
                showPanel={showPanel}
                items={items}
                parsedLocation={locationParams}
                togglePanel={this.togglePanel}
              />
            </ClickOutside>
          </OnKeyDown>
        )}
      </div>
    )
  }
}

FiltersCompatibleWith.propTypes = {
  items: PropTypes.array.isRequired,
  locationParams: PropTypes.object.isRequired
}

export default FiltersCompatibleWith
